import { GetQueryByIdParams } from '../../types';
import { Campaign } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

export const getCampaignById = async (
  params: GetQueryByIdParams<Campaign, Record<string, string>>,
): Promise<Campaign> => {
  return await tinctApi.campaigns.getCampaign(params);
};

export const useGetCampaignById = (
  params: GetQueryByIdParams<Campaign, Record<string, string>>,
  options?: Omit<UseQueryOptions<Campaign, ApiError>, 'queryKey'>,
) =>
  useQuery({
    queryKey: ['campaign', params.id, params.fields, params.staticParams],
    queryFn: () => getCampaignById(params),
    ...options,
  });
